import React, { ReactNode } from "react";
import { Button } from "@mui/material";
import styles from './CustomButton.module.css';

type CustomButtonType = {
    children: ReactNode;
    buttonType?: any;
    onClick?: Function;
    className?: any;
    disabled?: boolean;
    color?: any;
    component?: any;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
    sx?: any;
}

const CustomButton = (props: CustomButtonType) => {
    return (
        <div className={props.className}>
            { (props.buttonType == null || props.buttonType === 'contained') &&
                <Button
                    onClick={() => props.onClick && props.onClick()}
                    variant={props.buttonType || 'contained'}
                    disabled={props.disabled}
                    color={props.color}
                    component={props.component}
                    startIcon={props.startIcon}
                    endIcon={props.endIcon}
                    sx={() => {
                        const style = {
                            borderColor: props.color,
                            color: props.color,
                            textTransform: 'none',
                            fontFamily: 'Lexend',
                            fontWeight: 700,
                            borderRadius: '10px',
                        };

                        return ({
                            ...style,
                            ...props.sx
                        });
                    }}
                    className={styles.containedBtn}
                >
                    {props.children}
                </Button>
            }

            { props.buttonType === 'outlined' &&
                <Button
                    onClick={() => props.onClick && props.onClick()}
                    variant={props.buttonType || 'contained'}
                    disabled={props.disabled}
                    color={props.color}
                    component={props.component}
                    startIcon={props.startIcon}
                    endIcon={props.endIcon}
                    sx={() => {
                        const style = {
                            borderColor: props.color,
                            color: props.color,
                            textTransform: 'none',
                            fontFamily: 'Lexend',
                            fontWeight: 700,
                            borderRadius: '50px',
                        }

                        return {
                            ...style,
                            ...props.sx
                        }
                    }}
                    className={styles.outlinedBtn}
                >
                    {props.children}
                </Button>
            }

            { props.buttonType === 'text' &&
                <Button
                    onClick={() => props.onClick && props.onClick()}
                    variant={props.buttonType || 'text'}
                    disabled={props.disabled}
                    color={props.color}
                    component={props.component}
                    startIcon={props.startIcon}
                    endIcon={props.endIcon}
                    sx={{
                        borderColor: props.color,
                        color: props.color,
                        textTransform: 'none',
                        fontFamily: 'Lexend',
                        fontWeight: 700,
                        borderRadius: 0,
                        fontSize: '1rem',
                        borderBottom: '1px solid var(--blue)',
                    }}
                    className={styles.textBtn}
                >
                    {props.children}
                </Button>
            }
        </div>
    );
}

export default CustomButton;